import { connectPagination } from "instantsearch.js/es/connectors/index.js";

// Custom Pagination
export const chamfrPagination = connectPagination(
  (renderOptions, isFirstRender) => {
    const { pages, currentRefinement, nbPages, refine, widgetParams } =
      renderOptions;
    const container = widgetParams.container;

    // If there's only 1 page, hide the entire pagination
    if (nbPages <= 1) {
      container.innerHTML = "";
      return;
    }

    const hasPrevious = currentRefinement > 0;
    const hasNext = currentRefinement < nbPages - 1;

    container.innerHTML = `
		<ul class="pagination-list">
			${
        hasPrevious
          ? `
				<li class="pagination-list-item previous">
					<a href="#" class="pagination-list-link" data-value="${
            currentRefinement - 1
          }"></a>
				</li>`
          : ""
      }

			${pages
        .map(
          (page) => `
				<li class="pagination-list-item ${
          page === currentRefinement ? "selected" : ""
        }">
					<a href="#" class="pagination-list-link" data-value="${page}">${page + 1}</a>
				</li>
			`
        )
        .join("")}

			${
        hasNext
          ? `
				<li class="pagination-list-item next">
					<a href="#" class="pagination-list-link" data-value="${
            currentRefinement + 1
          }"></a>
				</li>`
          : ""
      }
		</ul>
	`;

    const links = container.querySelectorAll(".pagination-list-link");
    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const page = parseInt(event.currentTarget.dataset.value, 10);
        refine(page);
      });
    });
  }
);
